import { useQuery } from "@tanstack/react-query";

import { PER_PAGE_DEFAULT, QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { Prefecture } from "@lhd/types";

export const useFetchPrefectures = () => {
  return useQuery(
    [QUERY_NAME.PREFECTURES],
    () =>
      axios({
        method: "get",
        url: SERVICES.PREFECTURES,
        params: {
          page: 1,
          per_page: PER_PAGE_DEFAULT,
        },
      }).then((res) => (res.data as Prefecture[]) || []),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    },
  );
};

export const useFetchPrefecturesOptions = () => {
  return useQuery(
    [QUERY_NAME.PREFECTURES, "options"],
    () =>
      axios({
        method: "get",
        url: SERVICES.PREFECTURES,
        params: {
          page: 1,
          per_page: PER_PAGE_DEFAULT,
        },
      }).then((res) => {
        const data = res.data as Prefecture[];
        return data.map((item) => ({
          value: +item.id,
          label: item.name,
          code: item.code,
        }));
      }),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    },
  );
};
